var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-filter-wrapper',{attrs:{"label":_vm.$t('fields.occupations')}},[_c('OccupationSelect',{attrs:{"value":_vm.value,"multiple":""},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }